export const filterOptions = (values) => (options) => {
  return options && options.filter(({value}) => `${value}` === values);
};
